import * as React from 'react'
import Lottie from 'react-lottie'
// @ts-ignore
import * as animationData from '../img/loadingDots.json'
const Loader = () => (
  <Lottie options={{ animationData }} height={150} width={150} />
)

export default Loader



// WEBPACK FOOTER //
// ./src/shared/Loader.tsx